module.exports = __webpack_public_path__ + "static/img/组 12@2x.1602104c.png";